import React, { Component } from 'react';
import Trend from 'react-trend';
import Theme from 'Theme';
class GraphLine extends Component {
    render() {
        const { data } = this.props;
        const placeholder = Array.from({ length: 20 }, () => Math.floor(Math.random() * 10));
        return (React.createElement(Trend, { autoDraw: true, data: data || placeholder, stroke: Theme.color.primary, strokeOpacity: data && data.length > 2 ? 1 : 0.1, strokeWidth: 3, padding: Theme.common.size.space, smooth: true, radius: 20 }));
    }
}
export default GraphLine;



//////////////////
// WEBPACK FOOTER
// ./src/components/GraphLine.tsx
// module id = 487
// module chunks = 0